module.exports = __webpack_public_path__ + "img/blaked-cbd-leaf.f1c2ea38.svg";